import * as React from 'react';
import styled from 'styled-components';
import { greyColour, superLightGreyColour } from '../../cssConstants';
import { OldCardContainer } from './CardLayout';
import { DocumentDescription, DocumentItemHeader } from '../documentVault/sections/DocumentVaultListItemSection';

interface Props {
	title: string;
	description: string;
	className?: string;
}

const EmptyCard = ({ title, description, className }: Props) => {
	return (
		<OldCardContainer className={className}>
			<EmptyContainer>
				<DocumentItemHeader>
					<EmptyTitle>{title}</EmptyTitle>
				</DocumentItemHeader>
				<DocumentDescription $color={superLightGreyColour}>{description}</DocumentDescription>
			</EmptyContainer>
		</OldCardContainer>
	);
};

export default EmptyCard;

const EmptyContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 16px;
	height: 134px;
	width: 100%;
`;

const EmptyTitle = styled.p`
	color: ${greyColour};
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.1px;
	margin: 0;
	text-align: center;
`;

export const NoMarginEmptyCard = styled(EmptyCard)`
	margin-top: 0;
`;
